import { render, staticRenderFns } from "./gaikuang.vue?vue&type=template&id=6bffc477&scoped=true&"
import script from "./gaikuang.vue?vue&type=script&lang=js&"
export * from "./gaikuang.vue?vue&type=script&lang=js&"
import style0 from "../../../vab/styles/gaikuang/gaikuang_big.css?vue&type=style&index=0&id=6bffc477&prod&scoped=true&lang=css&"
import style1 from "../../../vab/styles/gaikuang/gaikuang_mid.css?vue&type=style&index=1&id=6bffc477&prod&scoped=true&lang=css&"
import style2 from "../../../vab/styles/gaikuang/gaikuang_small.css?vue&type=style&index=2&id=6bffc477&prod&scoped=true&lang=css&"
import style3 from "./gaikuang.vue?vue&type=style&index=3&id=6bffc477&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bffc477",
  null
  
)

export default component.exports